import { number, route, string } from 'react-router-typesafe-routes/dom';

export const routeMain = route('');

export const routeCabinet = route(
  'cabinet',
  {},
  {
    TICKETS: route('tickets'),
    TICKET: route('ticket/:id', {
      params: { id: number() },
      hash: ['feedback'],
    }),
    ORDERS: route('orders'),
    ORDER: route('order/:id', {
      params: { id: number() },
    }),
    REVIEWS: route('reviews', {
      params: { id: number() },
    }),
    NOTIFICATIONS_SETTINGS: route('notification-settings', {
      params: { id: number() },
    }),
  }
);

export const routeSearch = route('search', {
  searchParams: {
    startStation: number(),
    endStation: number(),
    lowDate: number(),
    highDate: number(),
  },
});

export const routeSignIn = route('sign-in', {
  searchParams: {
    continue: string(),
    tripid: number(),
    startStation: number(),
    endStation: number(),
  },
});
export const routeSignUp = route('sign-up', {
  searchParams: {
    continue: string(),
    tripid: number(),
    startStation: number(),
    endStation: number(),
  },
});
export const routeResetPassword = route('reset-password');

export const routeLogout = route('logout');

export const routeOrderTickets = route('order-tickets');

export const routeOrderStatus = route('order-status');

export const routePushNotifyRate = route('webpush/rate-trip', {
  searchParams: {
    orderId: number(),
    hash: string(),
  },
});
